import evaluateRestQuery from "@/remoteState/evaluateRestQuery";
import getAudioFileRequestBody from "./getAudioFileRequestBody";

const VOCALIZER_URL = process.env.NEXT_PUBLIC_VOCALIZER_URL || "/vocalizer";

const requestAudioFile = (text, language, playbackRate) => {
  const requestUrl = `${VOCALIZER_URL}/vocalization`;
  const requestBody = getAudioFileRequestBody(text, language, playbackRate);
  const requestConfig = {
    method: "POST",
    body: JSON.stringify(requestBody),
    headers: { "Content-Type": "application/json" },
  };

  const request = new Request(requestUrl, requestConfig);

  return evaluateRestQuery(request);
};

export default requestAudioFile;
